<template>
  <div class="account-header" :class="classes" :data-preload="[$options.name]">
    <div class="account-header__content">
      <div class="account-header__pretitle">
        {{ pretitle }}
      </div>
      <div class="account-header__title">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'AccountHeader',
  mixins: [globalMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    pretitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.account-header {
  display: flex;
  align-items: flex-end;
  margin-bottom: var(--space-2);
  font-weight: bold;
  color: var(--color-primary);
}

.account-header__pretitle {
  font-size: var(--font-size-S);
  line-height: var(--space-2--half);
}

.account-header__title {
  font-size: var(--font-size-LLXL);
  line-height: var(--space-3);
}
</style>
